<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import EventBus from '@/eventbus.js'
import { mapGetters } from 'vuex'
require('@/security.js')
export default {
  data() {
    return {
      lastActiveConversation: ''
    }
  },
  components: {},

  created() {
    let savedSession = this.glo('ssn')

    if (savedSession !== null) {
      this.$store.state.session = savedSession
    } else if (savedSession === null && window.location.pathname.includes('login')) {
    } else {
      this.$router.push({
        name: 'Login'
      })
    }
    let formData = {
      username: 'specclient',
      password: '8a0b4a90-6ca2-43e9-b554-9ac0a3b63541'
    }
    this.axios
      .post(process.env.VUE_APP_AUTHURL, formData)
      .then(response => {
        localStorage.setItem('spatkn', response.data.token)
        this.$store.state.token = response.data.token
      })
      // eslint-disable-next-line
      .catch(function(error) {
        console.log(error)
      })
  },
  mounted() {
    window.document.title = process.env.VUE_APP_APPNAME
    // console.log(this.invalidAuthFromWebSocket)
    EventBus.$on('connected_from_another_device', this.disconnectInFavorOfOtherDevice)
    EventBus.$on('invalid_auth_websocket1', this.invalidAuthFromWebSocket)
  },
  computed: {
    ...mapGetters(['unreadMessagesCountOfConversationTotal']),
    totalMessage() {
      let total = 0
      for (const iterator of this.$store.state.conversation.conversations) {
        total += iterator.UnreadMessageCount
      }
      for (const el of this.$store.state.group.groups) {
        total += el.UnreadMessageCount
      }
      for (const el of this.$store.state.channel.channels) {
        total += el.UnreadMessageCount
      }
      return total
    }
  },
  watch: {
    totalMessage: {
      handler(newValue, oldValue) {
        if (newValue !== undefined && newValue !== 0 && !isNaN(newValue)) {
          window.document.title = '(' + newValue + ')' + process.env.VUE_APP_APPNAME
        } else if (newValue === 0 || newValue === undefined) {
          window.document.title = '' + process.env.VUE_APP_APPNAME
        }
      }
    }
  },
  methods: {
    disconnectInFavorOfOtherDevice() {
      this.$store.state.socket.connection.close()
      this.rlo('ssn')
      this.$router.push({
        name: 'Login',
        params: {
          hasError: true,
          errorMessage: 'Başka bir tarayıcıdan giriş yapıldı.'
        }
      })
    },

    invalidAuthFromWebSocket() {
      this.$store.state.socket.connection.close()
      this.rlo('ssn')
      this.$router.push({
        name: 'Login',
        params: {
          hasError: true,
          errorMessage: 'Yetkilendirilemedi. Lütfen tekrar giriş yapınız. ****'
        }
      })
    }
  }
}
</script>

<style>
body,
html {
  height: 100vh;
  background-color: #ffffff;
  margin: 0;
  font-family: 'Raleway', sans-serif;
}

img {
  image-orientation: from-image;
}
</style>
